// Vendors
import { useQuery } from '@tanstack/react-query';

// Src
import { authenticationGetLoggedUser } from '../api/authenticationAPI';

export default function useUserQuery(userId?: number, access_token?: string) {
    return useQuery(
        ['auth'],
        () => {
            if (userId && access_token) {
                return authenticationGetLoggedUser(userId, access_token);
            }
            return null;
        },
        {
            enabled: !!userId && !!access_token,
        }
    );
}
